export default {
  statementsList: {
    path: {
      listPathName: '结算单列表',
      addPathName: '结算单创建',
      editPathName: '结算单编辑',
    },
    search: {
      slipCompanyNo: '公司代码',
      slipCompanyName: '公司名称',
      slipDepartmentNo: '事业部门',
      slipDate: '结算日期',
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      supplierNo: '供应链主体',
      orderNo: '业务订单',
      settleType: '结算类型',
      settleStatus: '结算批次状态',
      slipStatus: '结算单状态',
      productNo: '商品编码',
      productDesc: '商品描述',
    },
    table: {
      id: '序号',
      slipCompanyName: '公司名称',
      slipDepartmentName: '事业部门',
      slipNo: '结算单号',
      slipDesc: '结算单描述',
      orderNo: '业务订单号',
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      supplierName: '供应链主体',
      productNo: '商品编码',
      productDesc: '商品描述',
      settleQuantity: '结算数量',
      slipDate: '结算日期',
      slipCreatePersonName: '创建人',
      slipStatus: '结算单状态',
      mark: '备注',
    },
  },
  statementsAdd: {
    msg: {
      settleNoMsg: '请选择结算批次编号',
      noDepartment: '缺少对应部门，请维护',
      noImport: '结算批次编号已改变，请先导入结算数据再保存！',
    },
    buttons: {
      importSettlementBtn: '导入结算数据',
    },
    collapseTitle: {
      baseTitle: '基本信息',
      costTitle: '费用信息',
      detailTitle: '结算单明细信息',
    },
    tabsName: {
      procurement: '采购合同明细',
      salesContract: '销售明细',
      collection: '收款明细',
      payment: '付款明细',
      cost: '费用明细',
      fundsInterests: '资金利息',
    },
    baseForm: {
      slipNo: '结算单号',
      slipNoPlaceholder: '请输入结算单号',
      slipDesc: '结算单描述',
      slipDescPlaceholder: '请输入结算单描述',
      orderNo: '业务订单',
      orderNoPlaceholder: '请输入业务订单',
      slipCompanyNo: '公司代码',
      slipCompanyNoPlaceholder: '请选择公司代码',
      slipDepartmentNo: '部门',
      slipDepartmentNoPlaceholder: '请选择部门名称',
      slipDate: '结算日期',
      slipDatePlaceholder: '请选择结算日期',
      supplierName: '供应链主体',
      supplierNamePlaceholder: '请选择供应链主体',
      settleNo: '结算批次编号',
      settleNoPlaceholder: '请输入结算批次编号',
      settleDesc: '结算批次描述',
      settleDescPlaceholder: '请输入结算批次描述',
      productDesc: '商品描述',
      productDescPlaceholder: '请选择商品描述',
      settleQuantity: '结算数量',
      settleQuantityPlaceholder: '请输入结算数量',
      slipCreatePersonName: '创建人',
      slipCreatePersonNamePlaceholder: '请输入创建人',
      slipStatus: '结算单状态',
      slipStatusPlaceholder: '请选择结算单状态',
      mark: '备注',
      markPlaceholder: '请输入备注',
    },
    costDetail: {
      sortNo: '序号',
      expenseType: '费用类型',
      payableAmount: '应付金额',
      payedAmount: '已付金额',
      unpayAmount: '未付金额',
      receivableAmount: '可收金额',
      receivedAmount: '已收金额',
      unreceiveAmount: '未收金额',
      currencyName: '币别',
      benchmarkRate: '税率',
      taxDifference: '税差',
      profitAndLoss: '盈亏说明',
      profitAndLossPlaceholder: '请输入盈亏说明',
    },
  },
};
